import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { SearchClaimsCriteria } from 'src/app/feature-module/claims-data/models/SearchClaimsCriteria';
import { ClaimSearchResult } from '../models/ClaimSearchResult';


@Injectable({
  providedIn: 'root'
})
export class SearchClaimsService {

  constructor(private http: HttpClient,
    private configService: ConfigService) {
  }

  public searchClaims(criteria: SearchClaimsCriteria): Observable<ClaimSearchResult> {
    return this.http.post<ClaimSearchResult>(
      this.configService.PortalWebApiUrl + 'Claim/search', criteria);
  }
}
